/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_mt_output_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markdown output`)
};

const es_mt_output_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salida de Markdown`)
};

const de_mt_output_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markdown-Ausgabe`)
};

const nl_mt_output_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markdown-uitvoer`)
};

const fr_mt_output_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Résultat Markdown`)
};

const it_mt_output_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Output Markdown`)
};

const pt_br2_mt_output_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saída Markdown`)
};

const pt_mt_output_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saída Markdown`)
};

const ja_mt_output_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markdown 出力`)
};

const zh_mt_output_label = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markdown 输出`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const mt_output_label = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.mt_output_label(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("mt_output_label", locale)
	if (locale === "en") return en_mt_output_label(inputs)
	if (locale === "es") return es_mt_output_label(inputs)
	if (locale === "de") return de_mt_output_label(inputs)
	if (locale === "nl") return nl_mt_output_label(inputs)
	if (locale === "fr") return fr_mt_output_label(inputs)
	if (locale === "it") return it_mt_output_label(inputs)
	if (locale === "pt-BR") return pt_br2_mt_output_label(inputs)
	if (locale === "pt") return pt_mt_output_label(inputs)
	if (locale === "ja") return ja_mt_output_label(inputs)
	return zh_mt_output_label(inputs)
};